export const getLocalizedPrice = (): { symbol: string; amount: string } => {
  // Get user's locale from browser
  const locale = navigator.language;
  const isUK = locale.includes('GB') || locale.includes('uk');

  return {
    symbol: isUK ? '£' : '$',
    amount: '8.99'
  };
};